let get_translate = (lang, lista) => lista.filter(item => item.lang===lang)[0].trad

const module_name = [{ lang: 'pt', trad: 'Empresa' }, { lang: 'en', trad: 'Company' }]

export const language = (lang) => {
  
    return {
        sidebar_menu: {
            title: get_translate(lang, module_name) ,
            submenu: {
                regist: {
                    title: get_translate(lang, [{ lang: 'pt', trad: 'Registar' }, { lang: 'en', trad: 'Regist' }]),
                },
                list: {
                    title: get_translate(lang, [{ lang: 'pt', trad: 'Listar' }, { lang: 'en', trad: 'List' }]),
                },
                view: {
                    title: get_translate(lang, [{ lang: 'pt', trad: 'Visualizar' }, { lang: 'en', trad: 'View' }]),
                },
            }
        },

        module: {
            name: get_translate(lang, module_name),
            path_home: 'Home',
            path_module: get_translate(lang, [{ lang: 'pt', trad: 'MAIN' }, { lang: 'en', trad: 'MAIN' }]), 
            path_base: get_translate(lang, [{ lang: 'pt', trad: 'Base' }, { lang: 'en', trad: 'Base' }]),
            path_regist: get_translate(lang, [{ lang: 'pt', trad: 'Registar' }, { lang: 'en', trad: 'Regist' }]),
            path_list: get_translate(lang, [{ lang: 'pt', trad: 'Listar' }, { lang: 'en', trad: 'List' }]), 
            path_view: get_translate(lang, [{ lang: 'pt', trad: 'Visualizar' }, { lang: 'en', trad: 'View' }]),

        },
        main: {
            base: {
                dash_card_title: get_translate(lang, [{ lang: 'pt', trad: 'Base' }, { lang: 'en', trad: 'Base' }]), 
            },
            regist: {
                dash_card_title: get_translate(lang, [{ lang: 'pt', trad: 'Registar' }, { lang: 'en', trad: 'Regist' }]), 
            },
            list: {
                dash_card_title: get_translate(lang, [{ lang: 'pt', trad: 'Listar' }, { lang: 'en', trad: 'List' }]), 
            },
            view: {
                dash_card_title: get_translate(lang, [{ lang: 'pt', trad: 'Visualizar' }, { lang: 'en', trad: 'View' }]),
            },

        },
        options:{
            cancel: get_translate(lang, [{ lang: 'pt', trad: 'Cancelar' }, { lang: 'en', trad: 'Cancel' }]),
            save: get_translate(lang, [{ lang: 'pt', trad: 'Guardar' }, { lang: 'en', trad: 'Save' }]),
            delete: get_translate(lang, [{ lang: 'pt', trad: 'Apagar' }, { lang: 'en', trad: 'Delete' }]),
            language: get_translate(lang, [{ lang: 'pt', trad: 'Liguagem' }, { lang: 'en', trad: 'Language' }]),
            config: get_translate(lang, [{ lang: 'pt', trad: 'Configuração' }, { lang: 'en', trad: 'Configuration' }]),
            
            
            login_form: get_translate(lang, [{ lang: 'pt', trad: 'Dados de Login' }, { lang: 'en', trad: 'Logdin Data' }]),
            username: get_translate(lang, [{ lang: 'pt', trad: 'Nome de Utilizador' }, { lang: 'en', trad: 'Username' }]),
            password: get_translate(lang, [{ lang: 'pt', trad: 'Password' }, { lang: 'en', trad: 'Password' }]),
            password_confirmation: get_translate(lang, [{ lang: 'pt', trad: 'Comfirmação de Password' }, { lang: 'en', trad: 'Password Confirmation' }]),
           
            name: get_translate(lang, [{ lang: 'pt', trad: 'Nome' }, { lang: 'en', trad: 'Name' }]),
            name_placeholder: get_translate(lang, [{ lang: 'pt', trad: 'Introduza o Nome' }, { lang: 'en', trad: 'Insert Name' }]),
            personal_data: get_translate(lang, [{ lang: 'pt', trad: 'Dados Pessoais' }, { lang: 'en', trad: 'Personal Data' }]), 
            

        }

    }

}
   /*  en:
 {
     menu: {
         title: 'Workers',
         submenu: {
             regist: {
                 title: 'Regist'
             },
             list: {
                 title: 'List'
             },
             view: {
                 title: 'View'
             },
         },
     },
     module: {
         name: 'Example EN',
         path_home: 'Home',
         path_module: 'Home',
         path_base: 'Base',
         path_regist: 'Regist',
         path_view: 'View',
         path_list: 'List',

     },
     main: {
         base: {
             dash_card_title: 'Base'
         },
         regist: {
             dash_card_title: 'Regist'
         },
         list: {
             dash_card_title: 'List'
         },
         view: {
             dash_card_title: 'View'
         },

     }


 }
} */
